import { formatQuery } from "./paramFormat";
/* 获取跳转题库链接 
1、章节练习：http://wx.029985.com/center/study/tiku/chapter
2、每日一练：http://wx.029985.com/center/study/tiku/daily
3、历年真题：http://wx.029985.com/center/study/tiku/paper-past
4、模拟试题：http://wx.029985.com/center/study/tiku/paper-mock
5、易错题：http://wx.029985.com/center/study/tiku/easy-error
6、考前点题：http://wx.029985.com/center/study/tiku/yati
7、精选试题：http://wx.029985.com/center/study/tiku/selection

8、试卷详情：http://wx.029985.com/center/paper/detail/400704
*/
export function getTikuPath(type, params, paperId) {
  const paths = {
    1: "/center/study/tiku/chapter",
    2: "/center/study/tiku/daily",
    3: "/center/study/tiku/paper-past",
    4: "/center/study/tiku/paper-mock",
    5: "/center/study/tiku/easy-error",
    6: "/center/study/tiku/yati",
    7: "/center/study/tiku/selection",
    8: "/center/paper/detail/"
  };

  let path = paths[type];
  if (type == 8) {
    path = path + paperId;
  }
  return window.location.origin + path + formatQuery(params);
}
